export const articlePl = {
  breadcrumb_home: 'Strona główna',
  back_to_home: '← Powrót do strony głównej',
  read_more_articles: 'Więcej artykułów',
  related_articles: 'Powiązane artykuły',
  table_of_contents: 'Spis treści',
  author: 'Zespół Kakobuy Spreadsheet Polska',
  published: 'Opublikowano',
  updated: 'Zaktualizowano',
  share: 'Udostępnij',
};

export default articlePl;